import googleLogindApi from "../../api/google_login";
import * as mutationTypes from "../mutation-types";
import router from "../../routes/index";

const actions = {
  loginByGoogleIdToken ({ commit, dispatch, rootState }, params) {
    return new Promise((resolve) => {
      googleLogindApi.loginByGoogleIdToken((result) => {
        const { loggedIn, error } = result;
        commit(mutationTypes.ASSIGN_LOGGED_IN, { loggedIn });
        if (loggedIn === true) {
          dispatch("fetchCurrentDoctor", null, { root: true }).then(()=> {
            // 権限によりログイン先が変わる
            router.push(rootState.sessions.currentDoctor.homeUrl);
          });
        }
        resolve({ loggedIn, error });
      }, params);
    });
  }
};

export default {
  actions
};
